var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34.03 41.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#adadad;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 36.03,
    height: 43.95
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    className: "cls-3",
    d: "M23.67,35.32V27.77l-.05-5.51,0-1.24c0-1.64.27-2.5.83-2.63l.34,0c.68,0,1,.81,1,2.59v.77l0,6v7.71c0,1.71-.24,2.23-1,2.23s-1-.53-1-2.3ZM18,37.62c.76,0,1-.52,1-2.23V28l0-5.89V21c0-2.32-.53-2.62-1-2.63l-.33,0h0c-.55.13-.82,1-.82,2.63v1.26L17,28v7.33C17,37.09,17.25,37.62,18,37.62Zm-.43-19.88h0ZM11.36,37.62c.77,0,1-.52,1-2.23V28.07l.06-6.79V21c0-1.78-.3-2.58-1-2.6l-.34,0c-.55.13-.82,1-.82,2.62v1.33L10.35,28v7.34c0,1.76.23,2.29,1,2.29ZM35,13.48c0,1.15-.34,1.54-1.17,1.55l-.54,0-.36,0,0,.35c-.12,3.51-.32,7.44-.52,11.23L32,34.45l0,1.5c-.1,3.67-.18,6.57-3.3,7H7.4C4.27,42.46,4.19,39.62,4.09,36l0-1.64-.37-7.46c-.21-4-.43-8.12-.55-11.61v-.36l-.38,0-.52,0c-.83,0-1.13-.4-1.19-1.52,0-.5,0-2.9,0-3.79a3.21,3.21,0,0,1,.74-2.37c.74-.77,1.67-1.06,3.31-1.06H6.59l4.8,0,.32,0-.05-1.09C11.66,2.85,13.24,1,15.25,1H21a3,3,0,0,1,2.15.89A4.62,4.62,0,0,1,24.37,5.2l-.05,1,.31,0c.11,0,6.06.06,6.12.06C33,6.3,35,6.53,35,9.38c0,0,0,3.65,0,4.1Zm-29.9,4,.23,5.23L6,37.51c0,1.7.24,2.6.67,3a3.25,3.25,0,0,0,2.16.53l18.52,0a3.06,3.06,0,0,0,1.93-.49c.44-.43.64-1.4.67-3.26l.12-2.8c.21-4.71.65-14.49.81-19.15l0-.35H5.33C5,15,5,15,5.11,17.51ZM22,3.68A2.94,2.94,0,0,0,19.66,3h0s-3.12,0-3.32,0A3,3,0,0,0,14,3.74a2.47,2.47,0,0,0-.35,2l.1.55H22.3l.07-.49A2.65,2.65,0,0,0,22,3.68ZM33,12V9.57a1.37,1.37,0,0,0-.38-1,1.44,1.44,0,0,0-1-.39H4.88a3.45,3.45,0,0,0-1.13.14C3,8.6,3,9.56,3,10.07V13H33V12Z",
    transform: "translate(-1 -1)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletIcon);
export default __webpack_public_path__ + "static/media/deletIcon.70f36666db55b85d78a026a9274a868f.svg";
export { ForwardRef as ReactComponent };